export default function BackButton(props) {
  const { onNext, titleNext, total, hiddenBack, onBack, disabled } = props;
  return (
    <div
      className="bottom-stick"
      style={
        !total
          ? {
              background: "white",
              borderRadius: "16px 16px 0 0",
              boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              padding: 16,
              flexDirection: "row",
              justifyContent: "space-between",
              display: "flex",
            }
          : {
              flexDirection: "row",
              justifyContent: "space-between",
              display: "flex",
            }
      }
    >
      {!hiddenBack && (
        <button
          type="button"
          style={{
            color: "#009B4B",
            background: "#fff",
            border: "1px solid #009B4B",
            borderRadius: "8px",
            fontSize: 16,
            fontWeight: 600,
            width: "48%",
            padding: 5,
          }}
          onClick={onBack}
        >
          Quay lại
        </button>
      )}
      <button
        type="button"
        style={{
          color: !disabled ? "white" : "#9A9A9A",
          border: "none",
          background: !disabled ? "#009B4B" : "#F6F6F6",
          borderRadius: "8px",
          fontSize: 16,
          fontWeight: 600,
          width: !hiddenBack ? "48%" : "100%",
          padding: 5,
        }}
        onClick={onNext}
      >
        {titleNext || "Tiếp tục"}
      </button>
    </div>
  );
}
